import React from 'react';
import { Card, CardContent, CardActions } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import NeedsManager from '@utils/NeedsManager';
import { Select } from '@components/Inputs';
import { Button, Grid, Typography, IconButton, Icon } from '@ts/storybook';
import WhereClause from './WhereClause';
import { withTranslation } from 'react-i18next';
import WithAllPropsApp from '@utils/wrappers/WithAllPropsApp';

const ALL = 'all';

class RuleComponent extends React.Component {
  componentDidMount() {
    const { entityId } = this.props.rule;
    if (entityId) {
      const needs = [
        {
          url: `/api/entity/${entityId}`,
          dataPath: `entity_${entityId}`,
        },
      ];
      new NeedsManager(this.props.data, needs).fetchNeeds();
    }
  }

  render() {
    const { classes, rule, disabled, data } = this.props;
    const { entityId } = rule;

    if (data.getIn(['entities', 'data'])) {
      this.entities = data.getIn(['entities', 'data']);
    }

    const allSelected = rule?.data?.length && rule.data[0].fieldId?.split('.')[1] === ALL;

    return (
      <Card className="m-5">
        <CardContent>
          <Grid container size={{ xs: 12 }} spacing={2} className="grow">
            {this._renderFrom()}
            {this._renderWhere()}
          </Grid>
        </CardContent>
        <CardActions>
          <Button
            size="small"
            onClick={() => this._newWhereClause()}
            disabled={Boolean(disabled || !entityId || allSelected)}
            startIcon={<Icon className="mr-2 text-xl" icon="content-add" />}
            sx={{ marginLeft: '10px' }}
            label="New Condition"
          />
        </CardActions>
      </Card>
    );
  }

  _renderFrom() {
    const { disabled, rule, classes } = this.props;

    const { entityId, data } = rule;
    return (
      <Grid container size={{ xs: 12 }} spacing={2} alignItems="center" direction="row">
        <Grid size={{ sm: 3 }}>
          {this.entities && (
            <Select
              disabled={disabled}
              value={entityId}
              onChange={this._onChangeEntityId}
              label={'Table'}
              className="ml-2"
              fullWidth
              options={this.entities
                .map(entity => ({ value: entity.get('id'), label: entity.get('name') }))
                .unshift({ value: '', label: '' })}
            />
          )}
        </Grid>
        <Grid>{data?.length ? <Typography variant="subtitle1" className="pt-5 ml-5" text={['WITH', ':']} /> : null}</Grid>
        <IconButton icon="action-delete" disabled={disabled} onClick={this._onChangeDelete} />
      </Grid>
    );
  }

  _renderWhere() {
    const { rule, data: propsData, t } = this.props;
    const { entityId, data } = rule;
    const entitiesData = propsData?.get('entities')?.get('data')?.toJS();
    if (!entitiesData?.find(entity => entity.id === entityId)) return;

    return (
      <Grid container pl={2} spacing={2} alignItems="flex-start" direction="row" justify="flex-start">
        <Grid item size={{ sm: 11 }} />
        <Grid item size={{ sm: 11 }}>
          {data?.map((whereClause, index) => (
            <div key={index}>
              {index > 0 && (
                <div>
                  <br />
                  {t('AND')}
                </div>
              )}
              {this._renderWhereClause(whereClause)}
            </div>
          ))}
        </Grid>
      </Grid>
    );
  }

  _renderWhereClause(whereClause) {
    const copyWhereClause = { ...whereClause };
    const { disabled, app, data, rule } = this.props;
    const { entityId } = rule;
    if (!copyWhereClause?.id) copyWhereClause.id = uuidv4();
    return (
      <WhereClause
        disabled={disabled}
        entityId={entityId}
        key={copyWhereClause.id}
        id={copyWhereClause.id}
        whereClause={copyWhereClause}
        app={app}
        data={data}
        onChange={this._onChangeWhereClause(copyWhereClause.id)}
      />
    );
  }

  _newWhereClause() {
    const { rule, onChange } = this.props;
    const state = _.cloneDeep(rule);
    if (!state.data) {
      state.data = [];
    }
    state.data.push({ id: uuidv4() });
    onChange(state);
  }

  _onChangeWhereClause = id => value => {
    const { rule, onChange } = this.props;
    const state = _.cloneDeep(rule);
    const index = _.findIndex(state.data, clause => clause.id === id);
    if (value.isAlive === false) state.data.splice(index, 1);
    else if (value.fieldId.split('.')[1] === ALL) state.data = [value];
    else state.data[index] = value;
    onChange(state);
  };

  _onChangeDelete = () => {
    const { rule, onChange } = this.props;
    const state = _.cloneDeep(rule);
    state['isAlive'] = false;
    onChange(state);
  };

  _onChangeEntityId = value => {
    const { rule, onChange } = this.props;
    const state = _.cloneDeep(rule);
    state['entityId'] = value;
    if (value !== rule.entityId || (!value && rule.entityId)) {
      const needs = [
        {
          url: `/api/entity/${value}`,
          dataPath: `entity_${value}`,
        },
      ];
      new NeedsManager(this.props.data, needs).fetchNeeds();
    }
    state['data'] = [{ id: uuidv4() }];
    onChange(state);
  };
}

export default withTranslation()(WithAllPropsApp(RuleComponent));
